module.exports = __webpack_public_path__ + "img/Swiss-Air.a4c625ff.png";